/** App language from URL (?lang=), localStorage settings, or default ru-RU. */
import { readStoredSettings } from './settingsStorage';

export function getAppLanguage(): string {
  try {
    const fromUrl = new URLSearchParams(window.location.search).get('lang');
    if (fromUrl) {
      return fromUrl.toLowerCase().startsWith('en') ? 'en-US' : 'ru-RU';
    }
    const stored = readStoredSettings();
    return stored.language || 'ru-RU';
  } catch {
    return 'ru-RU';
  }
}

/** Short code for backend API (ru | en). */
export function getApiLang(language: string = getAppLanguage()): string {
  return language.toLowerCase().startsWith('en') ? 'en' : 'ru';
}
